import React, { useState } from 'react';
import { useTutorialVideos } from '../contexts/TutorialVideoContext';
import WalkthroughPickerModal from './WalkthroughPickerModal';

/**
 * WalkthroughButton
 *
 * Drop-in button that shows a walkthrough video picker for a given section.
 * Renders nothing if no active videos are configured for the section.
 *
 * Usage:
 *   <WalkthroughButton sectionKey="watchlist" />
 *   <WalkthroughButton sectionKey="screener" />
 */
export default function WalkthroughButton({ sectionKey }) {
  const { videos: videoMap } = useTutorialVideos();
  const [open, setOpen] = useState(false);

  // Context provides arrays per section_key
  const videos = videoMap[sectionKey];
  if (!videos || videos.length === 0) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{
          background: 'transparent',
          border: '1px solid #444',
          color: '#aeb9cc',
          fontSize: '12px',
          padding: '4px 12px',
          borderRadius: '20px',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '5px',
          transition: 'border-color 0.2s ease, color 0.2s ease',
          flexShrink: 0,
        }}
        onMouseEnter={e => {
          e.currentTarget.style.borderColor = '#218aff';
          e.currentTarget.style.color = '#218aff';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.borderColor = '#444';
          e.currentTarget.style.color = '#aeb9cc';
        }}
        aria-label={`Watch ${sectionKey} walkthroughs`}
      >
        <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
          <polygon points="1,0 10,5 1,10" />
        </svg>
        Walkthrough
      </button>
      <WalkthroughPickerModal
        isOpen={open}
        onClose={() => setOpen(false)}
        videos={videos}
      />
    </>
  );
}
